import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { POLARIS_NAME } from '../../copilot.model';

@Component({
  selector: 'app-empty-chat-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './empty-chat-message.component.html',
  styleUrl: './empty-chat-message.component.scss'
})
export class EmptyChatMessageComponent {
  readonly polarisName = POLARIS_NAME;
}
